module.exports = __webpack_public_path__ + "media/images/icon__compete@2x-46242601a7318a8a39cd192e9c71f2a4.png";